import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { homeSubContext, trackNav } from '../lib/tagitTrack';

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia('(max-width: 880px)').matches : false,
  );

  useEffect(() => {
    const media = window.matchMedia('(max-width: 880px)');
    const update = () => {
      const nextMobile = media.matches;
      setIsMobile(nextMobile);
      if (!nextMobile) {
        setMobileOpen(false);
      }
    };

    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);

  return (
    <header className="nav">
      <div className="container nav-inner">
        <Link
          to="/#top"
          className="brand"
          aria-label="tagIt home"
          onClick={() => setMobileOpen(false)}
        >
          <span className="brand-mark">tag</span>
          <span className="brand-mark outline">It</span>
        </Link>

        <nav className="nav-links" aria-label="Primary">
          <a
            href="https://tagit.gitbook.io/tagit"
            target="_blank"
            rel="noreferrer noopener"
            onClick={() => {
              trackNav(homeSubContext('documents'), 'external_click');
            }}
          >
            Documents
          </a>
          <a href="https://set.tagit.live" target="_blank" rel="noreferrer noopener">
            Login
          </a>
        </nav>

        <button
          type="button"
          className="nav-menu"
          aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {mobileOpen && isMobile ? (
        <div className="nav-drawer" role="navigation" aria-label="Mobile primary">
          <div className="container nav-drawer-inner">
            <a
              href="https://tagit.gitbook.io/tagit"
              target="_blank"
              rel="noreferrer noopener"
              onClick={() => {
                trackNav(homeSubContext('documents'), 'external_click');
                setMobileOpen(false);
              }}
            >
              Documents
            </a>
            <a
              href="https://set.tagit.live"
              target="_blank"
              rel="noreferrer noopener"
              onClick={() => {
                setMobileOpen(false);
              }}
            >
              Login
            </a>
          </div>
        </div>
      ) : null}
    </header>
  );
}
